import { arrayVariant } from "./answer-list.js";

const questionList = Array.from(document.querySelectorAll('.container-question__question'));

function changeQuestion () {
  let currentQuestion = document.querySelector('.container-question__question-active'),
      nextQuestion;
  
  for (let i = 0; i < questionList.length; i++) {
    if (questionList[i] == currentQuestion) {
      nextQuestion = questionList[i+1];
    }
  }
  
  if(nextQuestion == null) {
    window.location.href = './results-page.html';
  } else {
    nextQuestion.classList.add('container-question__question-active');
  }
  currentQuestion.classList.remove('container-question__question-active');
}

function findCurrentActiveQuestion() {
  const questionList = Array.from(document.querySelectorAll('.container-question__question'));

  let currentQuestion = document.querySelector('.container-question__question-active');
  
  for (let i = 0; i < questionList.length; i++) {
    if (questionList[i] == currentQuestion) {
      return i;
    }
  }
}

export {changeQuestion, questionList, findCurrentActiveQuestion};